import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import SvgComponent from "../SvgComponent/SvgComponent";

import { ExtraWrapper, ImagesContainer, PartImage } from "./style";
import { FixedStyle } from "./FixedStyle";

/* <ConservatoryImage /> represents a set of part Images
that together build up a visual representation of the
current conservatory configuration
*/
const ConservatoryImage = ({ smaller, frameType }) => {
  const { assetBaseUrl } = useSelector((state) => state.init);
  const {
    requestSize,
    requestSizeUpdate,
    requestDesign_Aggregated,
    requestDesignUpdate,
  } = useSelector((state) => state.requests.status);
  const ImagesObj = useSelector((state) => state.Images);
  const Uterum = useSelector((state) => state.Uterum);


  const { Images } = ImagesObj;
  
  const [zoomedIn, setZoomedIn] = useState(false);
  
  const hasError =
  requestSize === "rejected" ||
  requestSizeUpdate === "rejected" ||
  requestDesign_Aggregated === "rejected" ||
  requestDesignUpdate === "rejected" ||
  !Images ||
  Images.length <= 0;
  
  if (hasError) {
    return null;
  }
  
  const partImages = Images.map((image) => {
    return {
      id: `${image.ImageFolder}__${image.ImgAngle}__${image.Area}__${image.Img}`,
      src: `${assetBaseUrl}/store/uterumsguide2016/${image.ImageFolder}/${image.ImgAngle}/${image.Area}/${image.Img}.png`,
      alt: image.Img,
    };
  });

  return (
    <>
      <FixedStyle zoomedIn={zoomedIn} />
      {/* ExtraWrapper necessary for layout reasons */}
      <ExtraWrapper>
        <ImagesContainer onClick={() => setZoomedIn(!zoomedIn)}>
          {/* Placeholder fixes layout issues with position: absolute */}
          <PartImage
            className={"PartImage placeholder"}
            key={partImages[0].id}
            src={partImages[0].src}
            alt="Placeholder"
          />
          {partImages.map((image) => {
            const whiteFilter = (Uterum.PaintArticleErpId === '505081' || (Uterum.FramePrimed === 'YES' && Uterum.FrameColor === 'WHITE')) && image.src.includes('BASE') ? { filter: 'brightness(0.15) invert(1)' } : {};
            return (
              <PartImage
                className={`PartImage  ${frameType !== "FIRAXL" ? "animate" : ""
                  }`}
                frameType={frameType}
                smaller={smaller}
                isAnyLoading={false}
                key={image.id}
                src={image.src}
                alt={image.alt}
                style={whiteFilter}
              />
            );
          }
          )}
          <div className="zoom-icon-wrapper">
            <SvgComponent
              className="zoom-icon"
              name={zoomedIn ? "magnifyMinus" : "magnifyPlus"}
            />
          </div>
        </ImagesContainer>
      </ExtraWrapper>
    </>
  );
};

ConservatoryImage.propTypes = {
  smaller: PropTypes.bool,
  frameType: PropTypes.string,
};

export default ConservatoryImage;
